import React, {useState} from 'react';
import styles from './ReviewBox.module.css';
import Btn from "../../atoms/Btn";
import TextArea from "../../atoms/TextArea";
import SvgReviewIcon from "../../assets/icons/SvgReviewIcon";

const ReviewBox = ({ value, onChange }) => {
    const [show, setShow] = useState(false);
    return (
        <div className={styles.reviewBox}>
            {!show && <Btn onClick={() => setShow(!show)} label='Write a review' icon={<SvgReviewIcon/>}/>}
            {show && <TextArea onChange={onChange} value={value} label='Your review'/>}
        </div>
    );
};

export default ReviewBox;
